import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import * as headerSelect from './headers/header-select';

// import Cadastro from './cadastro/cadastro-component';
import CompletarCadastro from './cadastro/completar-cadastro-component';
import Entrar from './entrar/entrar-component';
import EntrarTelemarketer from './entrar/entrar-telemarketer-component';
import Logout from './logout/logout-component';
import AlterarSenha from './conta/alterar-senha-component';
import EsqueciSenha from './conta/esqueci-senha-component';
import AlterarEmail from './conta/alterar-email-component';
import LoginAssociado from './conta/login-associado-component';
import FinanceBanner from './commons/component/finance-banner';
import AcessoComponent from './conta/acesso-component';
import { isEmbedded } from './commons/query';
import DescadastroEmailComponent from './fast-registry/descadastro-email-component';
import ConfirmarDescadastroComponent from './fast-registry/confirmar-descadastro-component';
import ConfirmarCadastroComponent from './fast-registry/confirmar-cadastro-component';
import { SignUpFormProvider } from './cadastro/cadastro-context';
import CadastroCompradorContainer from './cadastro/comprador/cadastro-comprador-container';
import CadastroEmpresaContainer from './cadastro/empresa/cadastro-empresa-container';
import CadastroPjFinishComponent from './cadastro/cadastro-pj-finish-component';

class App extends Component {
  render() {
    return (
      <SignUpFormProvider>
        <Router basename="simple-login">
          <div>
            <Route
              path="/"
              render={({ location }) => (
                <div>
                  {!isEmbedded() && (
                    <div dangerouslySetInnerHTML={{ __html: headerSelect.select() }} />
                  )}
                  {headerSelect.isFinanceHeader() && <FinanceBanner />}
                </div>
              )}
            />
            <Switch>
              <Route path="/acesso" component={AcessoComponent} />
              <Route path="/alterar-email" component={AlterarEmail} />
              <Route path="/descadastro-email" component={DescadastroEmailComponent} />
              <Route path="/confirmar-descadastro" component={ConfirmarDescadastroComponent} />
              <Route path="/confirmar-cadastro" component={ConfirmarCadastroComponent} />
              <Route path="/esqueci-senha" component={EsqueciSenha} />
              <Route path="/alterar-senha" component={AlterarSenha} />
              <Route path="/completar-cadastro" component={CompletarCadastro} />
              <Route path="/cadastro/comprador" component={CadastroCompradorContainer} />
              <Route path="/cadastro/empresa" component={CadastroEmpresaContainer} />
              <Route path="/cadastro-concluido" component={CadastroPjFinishComponent} />
              <Route path="/logout" component={Logout} />
              <Route path="/login-atendente" component={EntrarTelemarketer} />
              <Route path="/login-associado" component={LoginAssociado} />
              <Route path="/" component={Entrar} />
              <Redirect to="/cadastro/comprador" />
            </Switch>
          </div>
        </Router>
      </SignUpFormProvider>
    );
  }
}

export default App;
